import React from 'react';
import { motion } from 'framer-motion';
import { Brain, Database, Cpu, Shield, Globe, Code } from 'lucide-react';

const ServiceCard = ({
  icon: Icon,
  title,
  description,
  delay,
}: {
  icon: any;
  title: string;
  description: string;
  delay: string;
}) => {
  return (
    <motion.div
      className="group bg-white rounded-xl p-8 border border-stone-200 shadow-sm hover:shadow-lg transition-all duration-300 hover:border-serchon-gold/50"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: parseFloat(delay) }}
    >
      <div className="w-14 h-14 bg-serchon-gold/10 rounded-lg flex items-center justify-center mb-6 group-hover:bg-serchon-gold transition-colors">
        <Icon className="w-7 h-7 text-serchon-gold group-hover:text-white transition-colors" />
      </div>
      <h3 className="font-serif text-xl font-bold text-stone-900 mb-3">{title}</h3>
      <p className="text-stone-600 leading-relaxed">{description}</p>
    </motion.div>
  );
};

const ServicesSection: React.FC = () => {
  const services = [
    {
      icon: Brain,
      title: '人工智能应用软件开发',
      description: '基于前沿 AI 技术，开发智能化应用解决方案，赋能企业数字化转型',
      delay: '0',
    },
    {
      icon: Database,
      title: '人工智能基础软件开发',
      description: '构建 AI 基础设施与平台，为各类 AI 应用提供坚实的技术支撑',
      delay: '0.1',
    },
    {
      icon: Code,
      title: '软件开发',
      description: '提供全栈软件开发服务，从前端到后端，打造定制化解决方案',
      delay: '0.2',
    },
    {
      icon: Globe,
      title: '软件外包服务',
      description: '专业的软件外包服务，助力企业降低成本、提升效率、聚焦核心业务',
      delay: '0.3',
    },
    {
      icon: Shield,
      title: '信息系统集成服务',
      description: '提供一站式信息系统集成解决方案，实现各系统间无缝对接与高效协同',
      delay: '0.4',
    },
    {
      icon: Cpu,
      title: '信息技术咨询服务',
      description: '提供专业的 IT 咨询服务，为企业信息化建设提供战略规划与技术指导',
      delay: '0.5',
    },
  ];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <span className="inline-block mb-4 text-xs font-bold tracking-widest text-serchon-gold uppercase">
              服务领域
            </span>
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-stone-900 mb-6">
              专业服务，助力企业成长
            </h2>
            <p className="text-lg text-stone-600 max-w-3xl mx-auto">
              我们提供全方位的技术服务，从人工智能到传统软件开发，满足企业多样化的数字化需求
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <ServiceCard
              key={index}
              icon={service.icon}
              title={service.title}
              description={service.description}
              delay={service.delay}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
